import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
// import { useSnackbar } from 'notistack';
import {
  Box,
  Container,
  Typography,
} from '@mui/material';
import clsx from 'clsx';

// import { AxiosError } from 'axios';
import { getInstitutionInfoByUrlExtension } from '../../requests/api/institutions';

// import handleApiResponse from '../../utils/handleApiResponse';

import Page from '../../components/Layout/Page';
import Logo from '../../components/Layout/Logo';
import LoginForm from './LoginForm';

import useStyles from './styles';
import UserInformationForm from './UserInformationForm';
import { Institution, InstitutionUser } from './types';
import parseToLocalDate from '../../utils/dates';

function LoginInstitutionsView() {
  const classes = useStyles();
  // const { enqueueSnackbar } = useSnackbar();
  const { institutionUrlExtension } = useParams<{ institutionUrlExtension: string }>();

  const initialValues = {
    id: null,
    role: '',
    rut: '',
    password: '',
    name: null,
    lastname: null,
    email: null,
    phoneNumber: null,
    school: null,
    schoolYear: null,
    preferredUniversity: null,
    preferredCarrer: null,
    deleted: false,
  };

  const [institutionUser, setInstitutionUser] = useState<InstitutionUser>(initialValues);

  const [institution, setInstitution] = useState<Institution>({
    id: null,
    name: '',
    urlExtension: institutionUrlExtension,
    logoUrl: '',
    institutionSessions: [{
      startDate: null,
      endDate: null,
      resultsDate: null,
    }],
  });

  useEffect(() => {
    const getInstitutionInfo = async () => {
      try {
        const response = await getInstitutionInfoByUrlExtension({ institutionUrlExtension });
        if (response.success) {
          if (typeof response.institution.institutionSessions[0].startDate === 'string') {
            response.institution.institutionSessions[0].startDate = parseToLocalDate(
              response.institution.institutionSessions[0].startDate,
            );
          }
          if (typeof response.institution.institutionSessions[0].endDate === 'string') {
            response.institution.institutionSessions[0].endDate = parseToLocalDate(
              response.institution.institutionSessions[0].endDate,
            );
          }
          if (typeof response.institution.institutionSessions[0].resultsDate === 'string') {
            response.institution.institutionSessions[0].resultsDate = parseToLocalDate(
              response.institution.institutionSessions[0].resultsDate,
            );
          }

          setInstitution(response.institution);
        }
      } catch (err) {
        // const e = err as AxiosError;
        // handleApiResponse(enqueueSnackbar, e, false);
      }
    };

    if (institutionUrlExtension && !institution.id) {
      getInstitutionInfo();
    }
  }, []);

  if (!institution.id) {
    return (
      <Page className={classes.noInstitutionRoot} title="Ingreso">
        {/* <Container className={classes.imageContainer}> */}
        {/* <Box className={classes.blueBox} /> */}
        <Box className={classes.infoContainer}>
          <Box className={classes.noInstitutionMessageContainer}>
            <Logo />
            <Typography className={classes.noInstitutionMessage}>
              La institución a la que intenta acceder no existe.
              <br />
              Por favor, revise la URL e intente nuevamente.
            </Typography>
          </Box>
        </Box>
        {/* </Container> */}
      </Page>
    );
  }

  return (
    <Page className={classes.root} title="Ingreso">
      {/* <Container className={classes.imageContainer}> */}
      {/* <Box className={classes.blueBox} /> */}
      <Box className={clsx(classes.infoContainer, classes.infoSide)}>
        <Box className={classes.loginTitle}>
          Bienvenido a la plataforma
          <br /> de rendición de ensayos de <br />
          <span>{institution.name}</span>
        </Box>
        <Box>
          <Typography className={classes.loginParagraph}>
            En la UAI queremos apoyar el proceso de orientación y preparación para la Prueba de
            Acceso a la Educación Superior (PAES) de los estudiantes, para un ingreso exitoso a
            la Universidad en Admisión 2026.
          </Typography>
          <Typography className={classes.loginParagraph}>
            ENSAYO PAES UAI ONLINE
          </Typography>
          <Typography className={classes.loginParagraph}>
            👉🏻 Dirigido a estudiantes que previamente realizaron su inscripción en
            el Ensayo PAES UAI Online (inscritos hasta jueves 24 de abril de 2025).
            <br />
            👉🏻 El Ensayo PAES UAI Online estará disponible desde el martes 29 de abril
            a las 12:00 h. hasta el martes 13 de mayo a las 23:59 h.
            <br />
            👉🏻 Entrega de resultados con puntaje, preguntas correctas, incorrectas, y
            omitidas mediante la visualización de un solucionario.
          </Typography>

          <Typography className={classes.loginParagraph}>
            RESULTADOS ENSAYO PAES UAI
            <br />
            Presencial en campus Peñalolén (Santiago) y Viña del Mar
          </Typography>
          <Typography className={classes.loginParagraph}>
            En este sitio podrás revisar el resultado del Ensayo PAES rendido
            presencialmente el sábado 12 de abril de 2025.
          </Typography>
          <Typography className={classes.loginParagraph}>
            👉🏻 Desde el martes 22 de abril hasta el viernes 2 de mayo de 2025.
            <br />
            👉🏻 Entrega de resultados con puntaje, preguntas correctas, incorrectas, y
            omitidas mediante la visualización de un solucionario.
          </Typography>
          <Typography className={classes.loginParagraph}>
            ¡Mucho éxito y esperamos contar con tu presencia en nuestras próximas actividades!
          </Typography>
        </Box>
      </Box>
      {/* </Container> */}
      {/* Renders the login form */}
      {institutionUser && !institutionUser.id ? (
        <Container className={classes.formContainer}>
          <Box className={classes.logosContainer}>
            <Logo />
            <img alt="Institution logo" src={institution.logoUrl} />
          </Box>
          <Box className={classes.inputsContainer}>
            <Typography className={classes.loginMessage}>
              Inicia sesión para utilizar la plataforma
            </Typography>
            <LoginForm
              institutionId={institution.id}
              urlExtension={institutionUrlExtension}
              setInstitutionUser={setInstitutionUser}
            />
          </Box>
        </Container>
      ) : null}
      {/* Renders the institution user information form */}
      {institutionUser && institutionUser.id && !institutionUser.name && !institutionUser.email ? (
        <Container className={classes.formContainer}>
          <Box className={classes.inputsContainer}>
            <Typography className={classes.institutionUserMessage}>
              Ingresa tu información académica
            </Typography>
            <UserInformationForm
              institutionUserId={institutionUser.id}
              initialValues={initialValues}
              setInstitutionUser={setInstitutionUser}
              urlExtension={institutionUrlExtension}
            />
          </Box>
        </Container>
      ) : null}
    </Page>
  );
}

export default LoginInstitutionsView;
